import { Colors } from '../../../helpers/Colors';

const loginPageStyle = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    loginHeader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        width: '100%',
        height: '240px',
        textAlign: "center",
        // margin: '0 0 43px !important',
        backgroundImage: "  linear-gradient(296.02deg, #753CBE 0%, #3CC0C3 100%)"
    },
    vpnText: {
        fontFamily: 'Kalameh',
        fontSize: '14px',
        color: '#707070',
        textAlign: 'center',
        margin: '0',
        marginTop: '27px'
    },
    containerForm: {
        padding: '0 0 0 !important'
    },
    buttonContainer: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
    },
    ButtonStyle: {
        width: '80px',
        height: '80px',
        boxShadow: '-15px 15px 25px 0 rgba(172, 172, 172, 0.5), -15px -15px 25px 0 #ffffff',
        border: 'solid 1px #ffffff',
        backgroundColor: '#f5f5f5',
        borderRadius: '50% !important',
        textAlign: 'center',
        // color: '#753cbe',
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        fontWeight: 'bold !important',
        fontStretch: 'normal !important',
        fontStyle: 'normal !important',
        lineHeight: 'normal !important',
        color: '#753cbe !important'
    },
    // ButtonFirstStep:{
    //     marginTop: "98px !important",
    //
    // },
    ButtonLabel: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: '#753cbe !important'
    },
    cornerSpan: {
        fontFamily: 'Kalameh',
        color: '#707070',
        fontSize: '14px',
        textDecoration: 'none !important',
        textAlign: 'center',
        marginTop: '27px',
        cursor: 'pointer',
    },
    problem: {
        position: "relative",
        bottom: "20px",
        left: '20px'
    },
    tabStyle: {
        width: '50% !important',
        fontSize: '21px !important',
        fontFamily: "Kalameh !important",
        letterSpacing: '0 !important',
        padding: '17px !important',
        color: `${Colors.azure} !important`,
        maxWidth: '100% !important',
    },
    text: {
        color: '#707070',
        fontSize: '18px ',
        fontFamily: 'Kalameh',
        textAlign: 'center',
        fontWeight: '400',
        margin: '0',
        lineHeight: '36px'
    },
    boldText: {
        fontWeight: '700',
        color: 'rgba(117, 60, 190, 1)'
    },
    refresh: {
        position: "absolute",
        bottom: "20px",
        right: '20px',
        fontFamily: 'Kalameh',
        fontSize: '14px'
    },
    indicator: {
        "& .MuiTabs-indicator": {
            // display: "none"
            backgroundImage: " linear-gradient(121deg, #753cbe 18%, #3cc0c3 85%)"
        }
    },
    dialogText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        color: '#3cc0c3 !important',
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        fontWeight: 'bold !important'
    },
    dialogPurpleText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        fontSize: "14px !important",
        fontFamily: 'Kalameh !important',
        textAlign: "center !important",
        color: `${Colors.purple} !important`,
        fontWeight: 'bold !important',
        paddingTop: '30px'
    },
    dialogLongText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        color: '#222222 !important',
        fontFamily: 'Kalameh !important',
        fontSize: '14px !important',
        fontWeight: 'bold !important',
        textAlign: 'center'
    },
    purpleText: {
        color: `${Colors.purple} !important`,
    },

    dialogButton: {
        width: '80% !important',
        borderRadius: '14px !important',
        boxShadow: '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5) !important',
        backgroundColor: '#ffffff !important',
        border: '1px solid #ebebeb !important',
        fontWeight: 'bold !important',
        fontFamily: 'Kalameh !important',
        fontSize: '12px !important',
        padding: " 10px 23px !important"
    },
    scannerStyle: {
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        fontWeight: '400 !important',
        textAlign: 'left',
        color: '#707070 !important',
    },
    label: {
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        fontWeight: '400 !important',
        letterSpacing: 0,
        color: '#707070 !important',
        marginRight: '14px !important'
    },
    selectedLabel: {
        color: `${Colors.purple} !important`,

    },
    noResult: {
        fontFamily: 'Kalameh !important',
        fontWeight: 700,
        fontSize: '16px !important',
        margin: 0
    },
    provinceStyle: {
        width: '100%',
        marginTop: '20px',
        '& input': {
            width: '100%',
            height: '48px',
            borderRadius: '16px !important',
            border: 'solid 1px #ffffff',
            boxShadow:
                '8px -8px 20px 0 #ffffff, 8px 8px 20px 0 rgba(172, 172, 172, 0.5)',
            backgroundColor: '#f5f5f5',
            color: '#753cbe !important',
            fontFamily: 'Kalameh !important',
            fontSize: '16px !important',
            outline: 'none',
            fontWeight: "600",
            textAlign: 'center',
            '&::placeholder': {
                color: '#707070',
                fontWeight: "400"
            }
        }
    },
    errorStyle: {
        width: '100%',
        marginTop: ' 0.25rem',
        marginLeft: '14px',
        fontSize: '80%',
        color: '#dc3545',
    },
    OutlinedInputErrorStyle: {
        '& input': {
            border: 'solid 1px #dc3545 !important',
        }
    },
    agent:{
        fontFamily: 'Kalameh',
        fontSize: '18px',
        color: '#d8d8d8',
        textAlign: 'center',
    }
};
export default loginPageStyle;
